<template>
  <v-card border class="chronology-section" rounded="lg">
    <div class="d-flex align-center justify-space-between ga-2 pa-4">
      <span class="text-h6 font-weight-bold">{{ sectionTitles[name] }}</span>

      <div v-if="datasets.length" class="d-flex align-center ga-2">
        <v-chip
          v-if="terminatedCount"
          rounded="pill"
          color="grey-darken-1"
          size="small">
          {{ terminatedCount }} припин.
        </v-chip>
        <v-chip rounded="pill" color="grey-darken-1" size="small">
          {{ getSectionCountLabel(name, datasets) }}
        </v-chip>
      </div>
      <v-chip v-else rounded="pill" color="grey-darken-1" size="small">
        немає записів
      </v-chip>
    </div>

    <v-divider></v-divider>

    <div v-if="datasets.length" class="pa-2">
      <template v-for="(dataset, index) in datasets" :key="dataset.id">
        <v-divider v-if="index" class="my-1"></v-divider>
        <chronology-dataset :dataset="dataset"></chronology-dataset>
      </template>
    </div>
    <div v-else class="pa-4 text-disabled">
      За цим боржником інформація в розділі не подавалася.
    </div>
  </v-card>
</template>

<script lang="ts">
import { computed, PropType } from 'vue'
import type {
  ChronologySectionName,
  ChronologyDataset as ChronologyDatasetType,
} from '@/utils/types'
import ChronologyDataset from './ChronologyDataset.vue'
import {
  sectionTitles,
  getTerminatedCount,
  getSectionCountLabel,
} from './helpers'

export default {
  name: 'ChronologySection',
  components: { ChronologyDataset },
  props: {
    name: {
      type: String as PropType<ChronologySectionName>,
      required: true,
    },
    datasets: {
      type: Array as PropType<ChronologyDatasetType[]>,
      default: () => [],
    },
  },
  methods: { getSectionCountLabel },
  setup(props) {
    const terminatedCount = computed<number>(() => {
      return getTerminatedCount(props.datasets)
    })

    return { sectionTitles, terminatedCount }
  },
}
</script>

<style scoped lang="scss"></style>
